// extracted by mini-css-extract-plugin
export default {"image":"ModalImagenBarbeibot_image__9TZmT"};